import React, { useRef } from 'react';
import { connect } from 'react-redux';

import {
    DELIVERY_ALIPAY,
    DELIVERY_BANK_ACCOUNT,
    DELIVERY_CASH,
    DELIVERY_HOME,
    DELIVERY_INTERAC,
    DELIVERY_PEOPLE_TRUST_INTERAC,
    DELIVERY_UPI,
    DELIVERY_WALLET,
} from 'constants/Constants';
import { AMOUNT_TO } from 'constants/fieldsName';
import { RULES } from 'constants/UrlConstants';
import {
    CANADA,
    CHINA,
    INDIA,
    KOREA,
    LEBANON,
    MEXICO,
    NIGERIA,
    PAKISTAN,
    PHILIPPINES,
    REPUBLIC_OF_SOUTH_AFRICA,
    USA,
    VIETNAM,
} from 'constants/WellKnownCountries';

import { getLangCountryPrefix, resolveArguments } from 'helpers/utils';

import { useExtra, usePageMessages } from 'hooks/selectors';

import { FeeTable, FeeTableRightBlock, FeeTableRow, FeeTableSeparator } from './styles';
import { LightDangerouslyHtml } from '../../no-auth/common/fromAuth/LightDangerouslyHtml/LightDangerouslyHtml';
import { PromoDangerouslyHtml } from '../../no-auth/common/promo-dangerously-html/PromoDangerouslyHtml';
import { PromoIcon } from '../../no-auth/common/promo-icon/PromoIcon';
import { PromoText } from '../../no-auth/common/promo-text/PromoText';
import PromoPopup from '../../no-auth/popup/PromoPopup';
import PromoPopupButton from '../../no-auth/popup/PromoPopupButton';
import PromoSimplePopup from '../../no-auth/popup/PromoSimplePopup';

const SEPARATOR = ':';

const FeeBlock = ({ disableSeparator = false, isLanding = false, isLock = false, ...props }) => {
    const popupRef = useRef(null);

    const {
        feeCmsText,
        feeRateText,
        feeLandingCommissionInfo,
        feeLandingCloseTitle,
        feeLandingTermsAndCond,
        feeRatePopupCommentInfo,
        feeRatePopupUsaCommentInfo,
        feeLandingKoreaInfo,
        feeLandingPakistanInfo,
        feeLandingIndiaUPIInfo,
        feeLandingChinaAlipayInfo,
        feeLandingCanadaInteracInfo,
        feeLandingCanadaPeopleTrustInteracInfo,
        cashPickupGuide,
        cashHomeGuide,
        cashPickupVietcomBankGuide,
        feeLandingSARInfo,
    } = usePageMessages();

    const { hasPromoForFirstPayment } = useExtra();
    const paymentForm = props.paymentForm;
    const hasSeparator = paymentForm.description && paymentForm.description.indexOf(SEPARATOR);
    const hasBonusRateForPromoFirstPayment = hasPromoForFirstPayment && props.calculator?.commission?.bonusSpecialRate?.rate;

    const getRel = (countryToId, deliveryMethod) => {
        let rel = '';
        if (countryToId === KOREA && deliveryMethod === DELIVERY_BANK_ACCOUNT) {
            rel = 'noreferrer noopener nofollower';
        } else if (countryToId === CHINA && deliveryMethod === DELIVERY_ALIPAY) {
            rel = 'noreferrer noopener nofollower';
        } else if (countryToId === VIETNAM && deliveryMethod === DELIVERY_HOME) {
            rel = 'noreferrer noopener nofollower';
        }
        return rel;
    };
    const getTermsButtonText = (countryToId, deliveryMethod) => {
        let textLink = '';

        if (countryToId === KOREA && deliveryMethod === DELIVERY_BANK_ACCOUNT) {
            textLink = feeLandingKoreaInfo;
        } else if (countryToId === PAKISTAN && deliveryMethod === DELIVERY_WALLET) {
            textLink = feeLandingPakistanInfo;
        } else if (countryToId === INDIA && deliveryMethod === DELIVERY_UPI) {
            textLink = feeLandingIndiaUPIInfo;
        } else if (countryToId === CHINA && deliveryMethod === DELIVERY_ALIPAY) {
            textLink = feeLandingChinaAlipayInfo;
        } else if (countryToId === CANADA && deliveryMethod === DELIVERY_INTERAC) {
            textLink = feeLandingCanadaInteracInfo;
        } else if (countryToId === CANADA && deliveryMethod === DELIVERY_PEOPLE_TRUST_INTERAC) {
            textLink = feeLandingCanadaPeopleTrustInteracInfo;
        } else if (countryToId === NIGERIA && deliveryMethod === DELIVERY_CASH) {
            textLink = cashPickupGuide;
        } else if (countryToId === PHILIPPINES && deliveryMethod === DELIVERY_CASH) {
            textLink = cashPickupGuide;
        } else if (countryToId === VIETNAM && deliveryMethod === DELIVERY_CASH) {
            textLink = cashPickupVietcomBankGuide;
        } else if (countryToId === VIETNAM && deliveryMethod === DELIVERY_HOME) {
            textLink = cashHomeGuide;
        } else if (countryToId === MEXICO && deliveryMethod === DELIVERY_CASH) {
            textLink = cashPickupGuide;
        } else if (countryToId === REPUBLIC_OF_SOUTH_AFRICA && deliveryMethod === DELIVERY_BANK_ACCOUNT) {
            textLink = feeLandingSARInfo;
        } else {
            textLink = feeLandingTermsAndCond;
        }

        return textLink;
    };

    const getTermsHref = (countryToId, deliveryMethod, country, lang) => {
        let href = '';
        const chinaAlipayUrl = lang === 'zh' ? '//render.alipay.com/p/c/k6r3ebho' : '//render.alipay.com/p/c/k6r8dy25';

        if (countryToId === KOREA && deliveryMethod === DELIVERY_BANK_ACCOUNT) {
            href = 'https://tinyurl.com/Paysend-partner-E9pay';
        } else if (countryToId === INDIA && deliveryMethod === DELIVERY_UPI) {
            href = `${getLangCountryPrefix(lang, country)}/help/transfers/india`;
        } else if (countryToId === CHINA && deliveryMethod === DELIVERY_ALIPAY) {
            href = chinaAlipayUrl;
        } else if (countryToId === CANADA && deliveryMethod === DELIVERY_INTERAC) {
            href = `${getLangCountryPrefix(lang, country)}/help/transfers/canada-interac`;
        } else if (countryToId === NIGERIA && deliveryMethod === DELIVERY_CASH) {
            href = `${getLangCountryPrefix(lang, country)}/help/transfers/cash-pickup-in-nigeria`;
        } else if (countryToId === PHILIPPINES && deliveryMethod === DELIVERY_CASH) {
            href = `${getLangCountryPrefix(lang, country)}/help/transfers/cash-pickup-in-philippines`;
        } else if (countryToId === VIETNAM && deliveryMethod === DELIVERY_CASH) {
            href = `${getLangCountryPrefix(lang, country)}/help/transfers/cash-pickup-in-vietcombank`;
        } else if (countryToId === VIETNAM && deliveryMethod === DELIVERY_HOME) {
            href = `${getLangCountryPrefix(lang, country)}/help/transfers/home-delivery-in-vietnam`;
        } else if (countryToId === MEXICO && deliveryMethod === DELIVERY_CASH) {
            href = `${getLangCountryPrefix(lang, country)}/help/transfers/cash-pickup-in-mexico`;
        } else if (countryToId === LEBANON && deliveryMethod === DELIVERY_CASH) {
            href = `${getLangCountryPrefix(lang, country)}/help/transfers/cash-pickup-in-lebanon`;
        } else if (countryToId === REPUBLIC_OF_SOUTH_AFRICA && deliveryMethod === DELIVERY_BANK_ACCOUNT) {
            href = `${getLangCountryPrefix(lang, country)}/help/transfers/bank-transfer-to-south-africa`;
        } else {
            href = `${getLangCountryPrefix(lang, country)}${RULES}`;
        }

        return href;
    };

    const calcSum = (amountField) => {
        const getFee = (tariff, sum) => {
            if (tariff.percent === 0 && tariff.fix > 0) {
                return tariff.fix;
            }

            if (tariff.percent > 0 && tariff.fix === 0) {
                return (sum * tariff.percent) / 100;
            }

            return 0;
        };

        const calcFee = (sum) => {
            const tariffs = props.calculator?.commission?.tariffs;
            if (tariffs) {
                let tariff = tariffs.find((t) => t.from <= sum && sum <= t.to);

                if (tariff === undefined && tariffs.length > 1) {
                    const lastTariff = tariffs[tariffs.length - 1];
                    if (lastTariff && lastTariff.from <= sum && lastTariff.to <= sum) {
                        tariff = lastTariff;
                    }
                }

                if (tariff) {
                    return getFee(tariff, sum);
                } else {
                    const [firstTariff] = tariffs;
                    if (!firstTariff?.from && !firstTariff?.to) {
                        return getFee(firstTariff, sum);
                    }
                }

                return 0;
            }
        };

        const rate = props.calculator?.commission?.convertRate;
        const val = amountField.value.toString().replace(/ /g, '');
        const fee = calcFee(Number(val));
        return Number(val) / rate + fee;
    };

    const getFeeInfo = (isLandingRequest) => {
        const color = hasPromoForFirstPayment ? 'purple80' : 'gray80';

        if (isLandingRequest) {
            const amountField = props.fields[AMOUNT_TO];

            const view = (num) => {
                let [first, second] = num.split('.');
                const reverseSting = (str) => str.split('').reverse().join('');
                if (first) {
                    first = reverseSting(first);
                    first = first.match(/.{1,3}/g).join(' ');
                    first = reverseSting(first);
                }
                return [first, second].join('.');
            };

            const fee = hasPromoForFirstPayment ? '0.00' : view(calcSum(amountField).toFixed(2));

            return (
                <>
                    <PromoText color={color}>{fee}&nbsp;</PromoText>
                    <PromoText color={color}>{props.calculator?.commission?.restrictionFrom?.ccyIso}</PromoText>
                    <PromoIcon name="info-rounded" color={color} size="16px" leftIndent="8px" />
                </>
            );
        } else {
            const fee = resolveArguments(paymentForm.feeText, [hasPromoForFirstPayment ? '0.00' : props.feeAmount, props.fromIso]);
            return (
                <>
                    <PromoText color={color}>{fee}</PromoText>
                    {paymentForm.feeTextInfo && <PromoIcon name="info-rounded" color={color} size="16px" leftIndent="8px" />}
                </>
            );
        }
    };

    const isClickableFeeText = paymentForm.feeTextInfo || props.isLandingRequest || hasPromoForFirstPayment;

    const getSeparator = () => {
        return disableSeparator ? false : <FeeTableSeparator />;
    };

    const feePopup = (val) => {
        popupRef.current?.open(
            <PromoSimplePopup text={setHTML(val)} popupRef={popupRef}>
                {hasPromoForFirstPayment && (
                    <PromoPopupButton
                        iconName="arrow-forward"
                        rel={getRel(props.countryToId, props.deliveryMethod)}
                        target={'_blank'}
                        href={getTermsHref(props.countryToId, props.deliveryMethod, props.country, props.lang)}
                        text={getTermsButtonText(props.countryToId, props.deliveryMethod)}
                    />
                )}
                <PromoPopupButton
                    iconName="check"
                    text={feeLandingCloseTitle}
                    onClick={(e) => {
                        e.preventDefault();
                        popupRef.current?.close();
                    }}
                />
            </PromoSimplePopup>,
        );
    };

    const infoPopup = (text) => {
        popupRef.current?.open(
            <PromoSimplePopup text={text} popupRef={popupRef}>
                <PromoPopupButton
                    iconName="arrow-forward"
                    rel={getRel(props.countryToId, props.deliveryMethod)}
                    target={'_blank'}
                    href={getTermsHref(props.countryToId, props.deliveryMethod, props.country, props.lang)}
                    text={getTermsButtonText(props.countryToId, props.deliveryMethod)}
                />
                <PromoPopupButton
                    iconName="check"
                    text={feeLandingCloseTitle}
                    onClick={(e) => {
                        e.preventDefault();
                        popupRef.current?.close();
                    }}
                />
            </PromoSimplePopup>,
        );
    };

    const setHTML = (val) => <LightDangerouslyHtml dangerouslyHtml={val} />;

    const getRateInfo = () => {
        const colorForRate = hasBonusRateForPromoFirstPayment ? 'purple80' : 'gray80';
        let textForPopup;

        if (hasBonusRateForPromoFirstPayment) {
            textForPopup = paymentForm.feeTextInfo;
        } else if (props.countryId === USA) {
            textForPopup = feeRatePopupUsaCommentInfo;
        } else {
            textForPopup = feeRatePopupCommentInfo;
        }

        return (
            <FeeTableRow cursorPointer onClick={() => infoPopup(setHTML(textForPopup))} onKeyPress={() => infoPopup(setHTML(textForPopup))} tabIndex={'0'}>
                <PromoDangerouslyHtml color="gray80" dangerouslyHtml={feeRateText} />
                {getSeparator()}
                <FeeTableRightBlock>
                    <PromoText color={colorForRate}>{paymentForm.currencyRateText}</PromoText>
                    <PromoIcon name="info-rounded" color={colorForRate} size="16px" leftIndent="8px" />
                </FeeTableRightBlock>
            </FeeTableRow>
        );
    };

    return (
        <>
            <FeeTable isLock={isLock}>
                <FeeTableRow
                    cursorPointer={isClickableFeeText}
                    onClick={() => {
                        if (isClickableFeeText) {
                            paymentForm.feeTextInfo ? feePopup(paymentForm.feeTextInfo) : feePopup(feeLandingCommissionInfo);
                        }
                    }}
                    onKeyPress={() => {
                        if (isClickableFeeText) {
                            paymentForm.feeTextInfo ? feePopup(paymentForm.feeTextInfo) : feePopup(feeLandingCommissionInfo);
                        }
                    }}
                >
                    <PromoText ellipsis color="gray80">
                        {feeCmsText}
                    </PromoText>
                    {getSeparator()}
                    <FeeTableRightBlock data-testid="fee-span-fee-info">{getFeeInfo(props.isLandingRequest)}</FeeTableRightBlock>
                </FeeTableRow>
                {paymentForm.currencyRateText && (props.isLandingRequest || isLanding) && getRateInfo()}
                {paymentForm.currencyRateText && !props.isLandingRequest && !isLanding && (
                    <FeeTableRow
                        cursorPointer
                        onClick={() => {
                            feePopup(feeRateText);
                            infoPopup(setHTML(USA === props.countryId ? feeRatePopupUsaCommentInfo : feeRatePopupCommentInfo));
                        }}
                        onKeyPress={() => {
                            feePopup(feeRateText);
                            infoPopup(setHTML(USA === props.countryId ? feeRatePopupUsaCommentInfo : feeRatePopupCommentInfo));
                        }}
                        tabIndex={'0'}
                    >
                        <PromoDangerouslyHtml color="gray80" dangerouslyHtml={feeRateText} />
                        {getSeparator()}
                        <FeeTableRightBlock>
                            <PromoText color="gray80">{paymentForm.currencyRateText}</PromoText>
                            <PromoIcon name="info-rounded" color="gray80" size="16px" leftIndent="8px" />
                        </FeeTableRightBlock>
                    </FeeTableRow>
                )}
                {paymentForm.description && (
                    <FeeTableRow
                        cursorPointer={paymentForm.comment}
                        onClick={() => {
                            if (paymentForm.comment) {
                                infoPopup(setHTML(paymentForm.comment));
                            }
                        }}
                        onKeyPress={() => {
                            if (paymentForm.comment) {
                                infoPopup(setHTML(paymentForm.comment));
                            }
                        }}
                        tabIndex={'0'}
                    >
                        {hasSeparator && <PromoText color="gray80">{paymentForm.description.split(SEPARATOR)[0]}:</PromoText>}
                        {getSeparator()}
                        <FeeTableRightBlock data-testid="fee-span-description">
                            <PromoText color="gray80">{hasSeparator ? paymentForm.description.split(SEPARATOR)[1] : paymentForm.description}</PromoText>
                            {paymentForm.comment && <PromoIcon name="info-rounded" color="gray80" size="16px" leftIndent="8px" />}
                        </FeeTableRightBlock>
                    </FeeTableRow>
                )}
            </FeeTable>
            <PromoPopup ref={popupRef} />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        calculator: state.calculator,
        lang: state.language.lang,
        country: state.app.country,
        countryToId: state.calculator?.countryMenu?.countryTo?.id,
        deliveryMethod: state.calculator?.paymentForm?.deliveryMethod,
    };
};
export default connect(mapStateToProps, null)(FeeBlock);
